import { render, staticRenderFns } from "./PageSettingsStartsCategories.vue?vue&type=template&id=5687b230&"
import script from "./PageSettingsStartsCategories.vue?vue&type=script&lang=js&"
export * from "./PageSettingsStartsCategories.vue?vue&type=script&lang=js&"
import style0 from "./PageSettingsStartsCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports